import React, {createContext, useContext, useState} from "react"

const defaultBackground = "none";

// 1. Crear el contexto
const BackgroundContext = createContext();

// 2. Hook para usar el contexto
export const useBackground = () => {
    const ctx = useContext(BackgroundContext);
    if (!ctx) throw new Error("useBackground debe usarse dentro de BackgroundProvider");
    return ctx;
};

// 3. Provider
export const BackgroundProvider = ({children}) => {
    const [background, setBackground] = useState(defaultBackground);

    const handleSetBackground = (newBackground) => {
        setBackground(newBackground ?? defaultBackground);
    }

    return (
        <BackgroundContext.Provider value={{background, setBackground: handleSetBackground}}>
            {children}
        </BackgroundContext.Provider>
    );
};
